import { mixGetV1, mixPatchV1, mixPostV1, mixToken } from './mixin';
import { API_URL } from 'env';
import type {
  DailyChecklist,
  ChecklistHistoryItem,
  ChecklistHistoryResponse,
  ToggleItemPayload,
} from 'types/dailyChecklist';
import type { RoadmapResponse } from 'types/roadmap';

const BASE = '/api/v1/be';

export async function fetchChecklist(date?: string): Promise<DailyChecklist | null> {
  const res = await mixGetV1(`${BASE}/checklist`, date ? { date } : {});
  if (res?.daily_checklist_id) return res as DailyChecklist;
  return null;
}

export async function fetchChecklistHistory(month: string): Promise<ChecklistHistoryItem[]> {
  const res: ChecklistHistoryResponse = await mixGetV1(`${BASE}/checklist/history`, { month });
  if (res?.success) return res.data;
  return [];
}

export async function toggleChecklistItem(payload: ToggleItemPayload): Promise<void> {
  await mixPatchV1(`${BASE}/checklist/toggle`, payload);
}

export async function saveChecklistItemDetails(itemId: number, payload: Record<string, unknown>): Promise<void> {
  await mixPostV1(`${BASE}/checklist/save-details`, { item_id: itemId, payload });
}

export async function fetchRoadmap(): Promise<RoadmapResponse | null> {
  const res: RoadmapResponse = await mixGetV1(`${BASE}/roadmap`);
  if (res?.success) return res;
  return null;
}

export interface HandbookDoc {
  id: number;
  name: string;
  file_type: string;
  thumbnail_path: string | null;
  created_at: string;
}

export async function fetchHandbookList(): Promise<HandbookDoc[]> {
  const res = await mixGetV1(`${BASE}/handbook`);
  if (!res?.status) throw new Error(res?.message ?? 'Không thể tải handbook');
  const items = Array.isArray(res.data) ? res.data : [res.data];
  return items.map((d: any) => {
    const ext = (d.path ?? '').split('.').pop()?.toLowerCase() ?? '';
    const fileType = d.file_type && d.file_type !== 'other'
      ? d.file_type
      : ext === 'pdf' ? 'pdf'
      : (ext === 'xlsx' || ext === 'xls') ? 'excel'
      : 'other';
    return {
      id: d.id,
      name: d.name,
      file_type: fileType,
      thumbnail_path: d.thumbnail_path ?? null,
      created_at: d.created_at,
    };
  });
}

export async function fetchHandbookThumbnailUrl(docId: number): Promise<string | null> {
  const res = await fetch(`${API_URL}${BASE}/handbook/${docId}/thumbnail`, {
    headers: { Authorization: `Bearer ${mixToken()}` },
  });
  if (!res.ok) return null;
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}

export async function fetchHandbookPdfBytes(docId: number): Promise<ArrayBuffer> {
  const res = await fetch(`${API_URL}${BASE}/handbook/${docId}/stream`, {
    headers: { Authorization: `Bearer ${mixToken()}` },
  });
  if (!res.ok) throw new Error(`Không thể tải file: ${res.status}`);
  return res.arrayBuffer();
}
